import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'

export const RevenueNote = () => {
  return <Translation htmlAvailable text={getFormedEltTranslation('revenue-note')} />
}
